import { CommonModule, NgClass } from '@angular/common';
import { Component, EventEmitter, input, Input, output, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { Nl2brPipe } from 'shared/pipes/nl2br.pipe';

@Component({
    selector: 'app-popup-header',
    templateUrl: './popup-header.component.html',
    styleUrl: './popup-header.component.scss',
    imports: [TranslateModule, MatIcon, NgClass, Nl2brPipe, CommonModule]
})
export class PopupHeaderComponent {
  @Input() public title!: string;
  @Input() public subTitle?: string;
  @Input() public showBorder: boolean | undefined = true;
  @Output() public closePopup = new EventEmitter<void>();
  public showBack = input(false);
  public onBack = output();

  public onClose(): void {
    this.closePopup.emit();
  }

  public onBackClick(): void {
    this.onBack.emit();
  }
}
